const PRODUCTION_PROJECT = "pos-brokers-production";
const PRODUCTION_URL = "https://app.posbrokers.com";

/**
 * Base URL of the merchant application for the Firebase project this build
 * talks to, without a trailing slash. Production has its own domain, any other
 * project is served from its default Firebase Hosting domain, so a link made
 * on staging opens the staging application.
 */
/**
 * The same application on the project's Firebase Hosting domain. The link to
 * an application a rep started has always used this domain, production
 * included, so it keeps it.
 */
export const merchantHostingUrl = (
  projectId: string | undefined = process.env.REACT_APP_FIREBASE_PROJECT_ID
): string => `https://${projectId || PRODUCTION_PROJECT}.web.app`;

export const merchantAppUrl = (
  projectId: string | undefined = process.env.REACT_APP_FIREBASE_PROJECT_ID
): string =>
  !projectId || projectId === PRODUCTION_PROJECT
    ? PRODUCTION_URL
    : `https://${projectId}.web.app`;
